import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

export class SkeletonAuctionCard extends React.Component {
    render() {
        const count = this.props.count || 3;

        return (
            <div>
                <div className="as-slider-track-wrap">
                    <div className="as-slider-track" style={{ transform: 'translateX(0%)' }}>
                        {Array(count).fill(0).map((_, i) => (
                            <div className="as-slide" key={i}>
                                <div className="re-auc-card" style={{ pointerEvents: 'none' }}>

                                    {/* Image area */}
                                    <div className="re-auc-img-wrap">
                                        <Skeleton height="100%" style={{ display: 'block', lineHeight: 'unset' }} />
                                    </div>

                                    {/* Body */}
                                    <div className="re-auc-body">

                                        {/* Topline */}
                                        <div className="re-auc-topline">
                                            <div className="re-auc-topline__info" style={{ flex: 1 }}>
                                                <Skeleton width={80} height={12} borderRadius={4} style={{ marginBottom: 6 }} />
                                                <Skeleton width={110} height={11} borderRadius={4} style={{ marginBottom: 6 }} />
                                                <Skeleton height={18} borderRadius={4} style={{ marginBottom: 4 }} />
                                                <Skeleton width="70%" height={18} borderRadius={4} />
                                            </div>
                                            <div className="re-auc-topline__side">
                                                <Skeleton width={48} height={48} borderRadius={10} />
                                                <Skeleton width={52} height={26} borderRadius={8} />
                                            </div>
                                        </div>

                                        {/* Amounts grid */}
                                        <div className="re-auc-amounts">
                                            {Array(3).fill(0).map((_, j) => (
                                                <div className="re-auc-amount" key={j}>
                                                    <Skeleton width="60%" height={10} borderRadius={4} style={{ marginBottom: 6 }} />
                                                    <Skeleton height={20} borderRadius={4} />
                                                </div>
                                            ))}
                                        </div>

                                        {/* Dates row */}
                                        <div className="re-auc-dates">
                                            {Array(3).fill(0).map((_, j) => (
                                                <div className="re-auc-dates__col" key={j}>
                                                    <Skeleton width="60%" height={10} borderRadius={4} style={{ marginBottom: 5 }} />
                                                    <Skeleton width="80%" height={13} borderRadius={4} style={{ marginBottom: 3 }} />
                                                    <Skeleton width="55%" height={11} borderRadius={4} style={{ marginBottom: 3 }} />
                                                    <Skeleton width="65%" height={11} borderRadius={4} />
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    {/* Footer */}
                                    <div className="re-auc-footer">
                                        <Skeleton height={38} borderRadius={8} style={{ flex: 1 }} />
                                        <Skeleton height={38} borderRadius={8} style={{ flex: 1 }} />
                                    </div>

                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    }
}